import qs from "qs";
import React, { useEffect, useState } from 'react';
import axios from "axios";

function AddMoney() {
  const [error, setError] = useState("");
  const [amount, setAmount] = useState("");
  const [month, setMonth] = useState("");
  const [year, setYear] = useState(new Date().getFullYear());
  const [paymentType, setPaymentType] = useState("prepaid"); // Prepaid by default
  const [employeesData, setEmployeesData] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  // Postpaid-specific fields
  const [limit, setLimit] = useState("");
  const [restaurantName, setRestaurantName] = useState("");

  const professionalUserId = localStorage.getItem("professionalUserId");
  const authToken = localStorage.getItem("authToken");
  const [restaurants, setRestaurants] = useState([]);
  const [loadingRestaurants, setLoadingRestaurants] = useState(false);
  const [mobileNumber, setMobileNumber] = useState("");
  const [selectedRestaurants, setSelectedRestaurants] = useState([""]);

  useEffect(() => {
    if (paymentType !== "postpaid") return;

    const fetchRestaurants = async () => {
      try {
        setLoadingRestaurants(true);

        const token = localStorage.getItem("authToken");

        if (!token) {
          alert("Auth token missing. Please login again.");
          return;
        }

        const res = await axios.get(
          " https://backend.maamaas.com/food/api/vendors/restaurants/names",
          {
            headers: {
              Accept: "*/*",
              Authorization: `Bearer ${token}`, // ✅ ADD TOKEN
            },
          }
        );

        ////console.log("✅ Restaurant API Response:", res.data);

        // If API returns array directly
        if (Array.isArray(res.data)) {
          setRestaurants(res.data);
        }
        // If API returns wrapped response
        else if (Array.isArray(res.data.data)) {
          setRestaurants(res.data.data);
        } else {
          setRestaurants([]);
        }

      } catch (error) {
        console.error("❌ Failed to fetch restaurants", error.response || error);
        alert("Failed to load restaurant list");
      } finally {
        setLoadingRestaurants(false);
      }
    };

    fetchRestaurants();
  }, [paymentType]);


  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedIds([]);
    } else {
      setSelectedIds(employeesData.map(emp => emp.userId));
    }
    setSelectAll(!selectAll);
  };

  const handleSelectRow = (id) => {
    setSelectedIds(prev =>
      prev.includes(id) ? prev.filter(uid => uid !== id) : [...prev, id]
    );
  };

  // Prepaid payment
  const handleSendPrepaid = async () => {
    const token = localStorage.getItem("authToken");
    if (!amount || !month || !selectedIds.length) {
      alert("Please enter amount, select month and employees.");
      return;
    }

    if (!professionalUserId || !authToken) {
      alert("Professional User ID or Auth Token missing. Please login again.");
      return;
    }

    try {
      const apiUrl = `https://backend.maamaas.com/subscription/api/user/money/add/transfer`;

      for (const empId of selectedIds) {
        const employee = employeesData.find(emp => emp.userId === empId);
        if (!employee) continue;

        const url = `${apiUrl}?professionalUserId=${professionalUserId}&phoneNumber=${employee.phoneNumber}&amount=${amount}&month=${month.toUpperCase()}&year=${year}`;

        await axios.post(url, null, {
          headers: {
            "Authorization": `Bearer ${token}`,
            "accept": "*/*",
          },
        });

        //console.log(`Prepaid payment successful for ${employee.name}`);
      }

      alert("Prepaid payment successful ✅ for all selected employees");

      setAmount("");
      setMonth("");
      setSelectedIds([]);
      setSelectAll(false);

    } catch (error) {
      console.error("Prepaid Payment failed:", error.response || error.message);
      alert(
        "Prepaid Payment failed ❌" +
        (error.response?.data?.error ? `: ${error.response.data.error}` : "")
      );
    }
  };

  // Postpaid payment
  const handleSendPostpaid = async () => {

    if (
      !month ||
      !year ||
      !limit ||
      selectedRestaurants.some(r => !r) ||
      !selectedIds.length
    ) {
      alert("Please fill all Postpaid fields correctly.");
      return;
    }

    const professionalUserId = localStorage.getItem("professionalUserId");
    const token = localStorage.getItem("authToken");

    if (!professionalUserId || !token) {
      alert("Session expired. Please login again.");
      return;
    }

    const baseUrl =
      "https://backend.maamaas.com/subscription/api/user/postpaid/approval";

    try {
      for (const empUserId of selectedIds) {

        const employee = employeesData.find(emp => emp.userId === empUserId);
        if (!employee) continue;

        const params = {
          professionalUserId,
          phoneNumber: employee.phoneNumber,
          month: month.toUpperCase(),
          year,
          limit,
          restaurentname: selectedRestaurants, // ✅ MULTIPLE
          postpaid: true
        };

        //console.log("POSTPAID PARAMS:", params);

        await axios.post(baseUrl, null, {
          params,

          // ✅ THIS IS THE KEY FIX
          paramsSerializer: params =>
            qs.stringify(params, { arrayFormat: "repeat" }),

          headers: {
            Accept: "*/*",
            Authorization: `Bearer ${token}`
          }
        });

        //console.log(`✅ Postpaid approved for ${employee.name}`);
      }

      alert("Postpaid payment successful ✅");

      // Reset
      setLimit("");
      setSelectedRestaurants([""]);
      setSelectedIds([]);
      setSelectAll(false);

    } catch (error) {
      console.error("❌ Postpaid Payment failed:", error.response || error);
      alert(error.response?.data?.error || "Postpaid Payment failed ❌");
    }
  };








  // Fetch employees
  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const professionalUserId = localStorage.getItem("professionalUserId");
        const token = localStorage.getItem("authToken");

        if (!professionalUserId) {
          setError("Professional User ID missing.");
          return;
        }

        if (!token) {
          setError("Authentication token missing.");
          return;
        }

        // ✔ Correct Swagger URL format (NO QUERY PARAM)
        const apiUrl = `https://backend.maamaas.com/subscription/api/user/employee/getBy/${professionalUserId}`;

        // ✔ Correct axios call with headers
        const response = await axios.get(apiUrl, {
          headers: {
            Accept: "*/*",
            Authorization: `Bearer ${token}`,
          },
        });

        //console.log("Money Received API Response:", response.data);

        // ✔ Check response type & store
        if (Array.isArray(response.data)) {
          setEmployeesData(response.data);
        } else if (response.data?.employees) {
          setEmployeesData(response.data.employees);
        } else {
          setEmployeesData([]);
        }

        setError("");
      } catch (err) {
        console.error("Fetch Money Received Error:", err);
        setError("Error fetching money received details");
        setEmployeesData([]);
      }
    };

    fetchEmployees();
  }, []);

  const handleRestaurantChange = (index, value) => {
    const updated = [...selectedRestaurants];
    updated[index] = value;
    setSelectedRestaurants(updated);
  };

  const addRestaurantField = () => {
    setSelectedRestaurants([...selectedRestaurants, ""]);
  };

  const removeRestaurantField = (index) => {
    const updated = selectedRestaurants.filter((_, i) => i !== index);
    setSelectedRestaurants(updated);
  };
const inputStyle = {
  padding: "8px 10px",
  borderRadius: "6px",
  border: "1px solid #ccc",
  fontSize: "13px",
  height: "36px",
  background: "#fff"
};

const addBtnStyle = {
  height: "36px",
  background: "#1976d2",
  color: "#fff",
  border: "none",
  borderRadius: "6px",
  padding: "0 12px",
  cursor: "pointer",
  fontSize: "13px"
};

const removeBtnStyle = {
  height: "36px",
  width: "36px",
  background: "#ff4d4f",
  color: "#fff",
  border: "none",
  borderRadius: "6px",
  cursor: "pointer"
};

const prepaidBtn = {
  height: "36px",
  background: "#7b3fe4",
  color: "#fff",
  border: "none",
  borderRadius: "6px",
  padding: "0 16px",
  fontWeight: "600",
  cursor: "pointer"
};

const postpaidBtn = {
  ...prepaidBtn,
  background: "#4caf50"
};

  return (
    <div>

      
      <p3>Wallet Payment</p3>
      {/* Input Section */}
      <div
  style={{
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "14px",
    background: "#f9fafb",
    border: "1px solid #e0e0e0",
    borderRadius: "10px",
    flexWrap: "wrap"
  }}
>
  {/* Month */}
  <select
    value={month}
    onChange={(e) => setMonth(e.target.value)}
    style={inputStyle}
  >
    <option value="">Month</option>
    {[
      "January","February","March","April","May","June",
      "July","August","September","October","November","December"
    ].map(m => (
      <option key={m} value={m}>{m}</option>
    ))}
  </select>

  {/* Year */}
  <input
    type="number"
    placeholder="Year"
    value={year}
    onChange={(e) => setYear(e.target.value)}
    style={{ ...inputStyle, width: "90px" }}
  />

  {/* Payment Type */}
  <select
    value={paymentType}
    onChange={(e) => setPaymentType(e.target.value)}
    style={{ ...inputStyle, width: "130px" }}
  >
    <option value="prepaid">Prepaid</option>
    <option value="postpaid">Postpaid</option>
  </select>

  {/* Prepaid Amount */}
  {paymentType === "prepaid" && (
    <input
      type="number"
      placeholder="Amount"
      value={amount}
      onChange={(e) => setAmount(e.target.value)}
      style={{ ...inputStyle, width: "120px" }}
    />
  )}

  {/* Postpaid Fields */}
  {paymentType === "postpaid" && (
    <>
      {/* Limit */}
      <input
        type="number"
        placeholder="Limit"
        value={limit}
        onChange={(e) => setLimit(e.target.value)}
        style={{ ...inputStyle, width: "110px" }}
      />

      {/* Restaurants */}
      {selectedRestaurants.map((rest, index) => (
        <div key={index} style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <select
            value={rest}
            onChange={(e) =>
              handleRestaurantChange(index, e.target.value)
            }
            style={{ ...inputStyle, minWidth: "200px" }}
          >
            <option value="">
              {loadingRestaurants ? "Loading..." : "Restaurant"}
            </option>
            {restaurants.map((r, i) => (
              <option key={i} value={r}>{r}</option>
            ))}
          </select>

          {selectedRestaurants.length > 1 && (
            <button
              type="button"
              onClick={() => removeRestaurantField(index)}
              style={removeBtnStyle}
            >
              ✕
            </button>
          )}
        </div>
      ))}

      {/* Add Another */}
      <button
        type="button"
        onClick={addRestaurantField}
        style={addBtnStyle}
      >
        + Add
      </button>
    </>
  )}

  {/* Action Button */}
  <button
    onClick={paymentType === "prepaid" ? handleSendPrepaid : handleSendPostpaid}
    style={paymentType === "prepaid" ? prepaidBtn : postpaidBtn}
  >
    {paymentType === "prepaid" ? "Send Prepaid" : "Send Postpaid"}
  </button>
</div>


      {/* Employees Table */}
      <table style={tableStyle}>
        <thead>
          <tr>
            <th style={tableHeaderStyle}><input type="checkbox" checked={selectAll} onChange={handleSelectAll} /></th>
            <th style={tableHeaderStyle}>S.No</th>
            <th style={tableHeaderStyle}>Name</th>
            <th style={tableHeaderStyle}>Email</th>
            <th style={tableHeaderStyle}>Phone</th>
            <th style={tableHeaderStyle}>Employee ID</th>
            <th style={tableHeaderStyle}>App User ID</th>
          </tr>
        </thead>
        <tbody>
          {employeesData.map((item, index) => (
            <tr key={item.id || index}>
              <td style={tableCellStyle}>
                <input
                  type="checkbox"
                  checked={selectedIds.includes(item.userId)}
                  onChange={() => handleSelectRow(item.userId)}
                />
              </td>
              <td style={tableCellStyle}>{index + 1}</td>
              <td style={tableCellStyle}>{item.name}</td>
              <td style={tableCellStyle}>{item.email}</td>
              <td style={tableCellStyle}>{item.phoneNumber}</td>
              <td style={tableCellStyle}>{item.empid}</td>
              <td style={tableCellStyle}>{item.userId}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {error && <p style={{ color: "red" }}>{error}</p>}
    </div>
  );
}

// Styles
const tableStyle = { width: "100%", borderCollapse: "collapse", marginTop: "10px" };
const tableHeaderStyle = { border: "1px solid #ddd", padding: "8px", backgroundColor: "#ee6521", color: "white", textAlign: "center" };
const tableCellStyle = { border: "1px solid #ddd", padding: "6px", textAlign: "center" };

export default AddMoney;
